import React from "react";
import { formatCurrency } from "../lib/api";

export function PaymentOptions({ options, testId = "payment-options" }) {
  if (!options?.length) return null;
  return (
    <div className="mt-5 rounded-lg border border-slate-200 bg-slate-50 p-4" data-testid={testId}>
      <div className="text-xs uppercase tracking-wider text-slate-500 font-medium mb-2">Opções de pagamento</div>
      <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-1.5 text-sm">
        {options.map((o) => (
          <li key={o.name} className="flex justify-between gap-3">
            <span className="text-slate-700">{o.name}</span>
            <span className="font-mono-nums font-semibold text-slate-900 whitespace-nowrap">
              {o.installments ? `${o.installments}x ${formatCurrency(o.installment_value)}` : formatCurrency(o.total)}
              {o.installments ? <span className="text-xs text-slate-500 font-normal"> = {formatCurrency(o.total)}</span> : null}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export const QUOTE_STATUS = {
  pending: { label: "Pendente", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  approved: { label: "Aprovado", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  lost: { label: "Perdido", cls: "bg-slate-100 text-slate-600 border-slate-200" },
};

export function QuoteStatusSelect({ value, onChange, testId }) {
  return (
    <select value={value || "pending"} onChange={(e) => onChange(e.target.value)} onClick={(e) => e.stopPropagation()}
      className={`text-xs font-semibold rounded-full border px-2 py-1 cursor-pointer ${QUOTE_STATUS[value || "pending"].cls}`} data-testid={testId}>
      {Object.entries(QUOTE_STATUS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
    </select>
  );
}
